import { Brand } from 'library/ts/model/enums/Brand';

/**
 * @description Brand-specific pre-playback loader SVG for Tag {@link LoadingAnimationManager}.
 *
 * Tag cannot import Skin's full SVG set at runtime (CTV / no-skin contexts). This module
 * carries only `iconLoader` — the two spinner variants used before Skin mounts.
 *
 * Keep in sync with Skin `iconLoader` in:
 * - `src/skin/ts/Skin/view/ui/svg/core.ts` (P+/CBS)
 * - `src/skin/ts/Skin/view/ui/svg/plutotv.ts` (Pluto)
 */
const LOADER_CORE =
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" class="svg-loader">' +
	'<g style="fill: rgba( 255, 255, 255, 0.8 ) !important;">' +
	'<path d="M8.16,138.48A99.6,99.6,0,0,0,49,185.78l5.8-14.07a84.94,84.94,0,0,1-.27-143.23l-5.83-14A100.06,100.06,0,0,0,8.16,138.48Z"/>' +
	'<path d="M199.54,85.9A100.13,100.13,0,0,0,76.29,3l5.83,14A85,85,0,0,1,184.38,85.9Z"/>' +
	'<path d="M138.94,192.39a100,100,0,0,0,60.34-76.6H184.07A84.86,84.86,0,0,1,82.43,183.1l-5.8,14.07A99.6,99.6,0,0,0,138.94,192.39Z"/>' +
	'</g>' +
	'</svg>';

const LOADER_PLUTO =
	'<svg viewBox="0 0 80 80" class="svg-loader" fill="none" xmlns="http://www.w3.org/2000/svg">' +
	'<circle cx="40" cy="40" r="34" fill="none" stroke="#666666" stroke-width="4" stroke-dasharray="213.63" stroke-dashoffset="0" class="circle-bg"/>' +
	'<circle cx="40" cy="40" r="34" fill="none" stroke="white" stroke-width="4" stroke-dasharray="213.63" stroke-dashoffset="213.63" class="circle-fill"/>' +
	'</svg>';

/**
 * @description Returns the brand loading spinner SVG for Tag (not the full control icon set).
 * Pluto uses the ring loader; P+, CBS, and unknown brands use the core 3-path spinner.
 */
export function getIconLoader( brand: Brand | string ): string {
	return brand === Brand.PLUTOTV ? LOADER_PLUTO : LOADER_CORE;
}